import { render, staticRenderFns } from "./PanelKurs.vue?vue&type=template&id=8eaa6b64&scoped=true&"
import script from "./PanelKurs.vue?vue&type=script&lang=js&"
export * from "./PanelKurs.vue?vue&type=script&lang=js&"
import style0 from "./PanelKurs.vue?vue&type=style&index=0&id=8eaa6b64&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eaa6b64",
  null
  
)

export default component.exports